export enum EventTypes {
  SHOW_LOADING_REPORT_BANNER = 'SHOW_LOADING_REPORT_BANNER',
  SHOW_REPORT_BANNER = 'SHOW_REPORT_BANNER',
  SHOW_HUBSPOT_REFRESH_BANNER = 'SHOW_HUBSPOT_REFRESH_BANNER',
  RELOAD_REPORTS = 'RELOAD_REPORTS',
  RELOAD_HUBSPOT = 'RELOAD_HUBSPOT',
  LOAD_NOTES_SUMMARY = 'LOAD_NOTES_SUMMARY',
  CLOSE_REPORT_BANNER = 'CLOSE_REPORT_BANNER',
  UPDATE_CREDITS = 'UPDATE_CREDITS',
  REPORT_NOT_GENERATED = 'REPORT_NOT_GENERATED',
  APOLLO_PHONE_NUMBER='APOLLO_PHONE_NUMBER',
  COMPANY_REVENUE='COMPANY_REVENUE',
  COMPANY_PROFIT='COMPANY_PROFIT',
  COMPANY_FUNDING='COMPANY_FUNDING',
  COMPANY_EMPLOYEES='COMPANY_EMPLOYEES',
  REPORT_FINISHED='REPORT_FINISHED',
  SEARCH_ERROR='SEARCH_ERROR'
}
